class AuthService {
  constructor() {
    this.token = window.localStorage.getItem(
      `${process.env.VUE_APP_NAME}_token`,
    );
    this.user = JSON.parse(
      window.localStorage.getItem(`${process.env.VUE_APP_NAME}_user`),
    );

    this.company = JSON.parse(
      window.localStorage.getItem(`${process.env.VUE_APP_NAME}_company`),
    );
  }

  check() {
    return !!this.token;
  }

  setUser(user) {
    window.localStorage.removeItem(`${process.env.VUE_APP_NAME}_user`);
    window.localStorage.setItem(
      `${process.env.VUE_APP_NAME}_user`,
      JSON.stringify(user),
    );
    window.localStorage.setItem(
      `${process.env.VUE_APP_NAME}_company`,
      JSON.stringify(user.company),
    );
    this.user = user;
    location.reload();
  }

  setApplicant(user) {
    window.localStorage.setItem(
      `${process.env.VUE_APP_NAME}_user`,
      JSON.stringify(user),
    );
    this.user = user;
  }

  setCompany(company) {
    window.localStorage.removeItem(`${process.env.VUE_APP_NAME}_company`);
    window.localStorage.setItem(
      `${process.env.VUE_APP_NAME}_company`,
      JSON.stringify(company),
    );
    this.company = company;
    location.reload();
  }

  login(token, user) {
    window.localStorage.setItem(`${process.env.VUE_APP_NAME}_token`, token);
    window.localStorage.setItem(
      `${process.env.VUE_APP_NAME}_user`,
      JSON.stringify(user),
    );
    window.localStorage.setItem(
      `${process.env.VUE_APP_NAME}_company`,
      JSON.stringify(user.company),
    );

    this.token = token;
    this.user = user;
    this.company = user.company;

    location.reload();
  }

  logout() {
    window.localStorage.removeItem(`${process.env.VUE_APP_NAME}_token`);
    window.localStorage.removeItem(`${process.env.VUE_APP_NAME}_user`);
    window.localStorage.removeItem(`${process.env.VUE_APP_NAME}_company`);
    window.localStorage.removeItem(
      `${process.env.VUE_APP_NAME}_profile_complete`,
    );
    window.location.href = "/";
  }
  timerLogout(logoutMessage) {
    window.localStorage.setItem("sessionExpiry", logoutMessage);
    window.localStorage.removeItem(`${process.env.VUE_APP_NAME}_token`);
    window.localStorage.removeItem(`${process.env.VUE_APP_NAME}_user`);
    window.localStorage.removeItem(`${process.env.VUE_APP_NAME}_company`);
    window.localStorage.removeItem(
      `${process.env.VUE_APP_NAME}_profile_complete`,
    );
    window.location.href = "/";
  }
}

export default new AuthService();
